module.exports = __webpack_public_path__ + "static/media/Azure_firstPage_ko.3174eb76.png";